import React from "react";
import { motion } from "framer-motion"; // Importing framer-motion
import LoadingButton from "./LoadingButton";

interface ButtonProps {
  className?: string; // Optional className prop
  buttonName: string;
  loading?: boolean;
  buttonDisabled?: boolean;
  buttonType?: boolean;
  handleClick?: () => void
  testId? : string;
}

const SecondaryButton: React.FC<ButtonProps> = ({ className, loading, buttonType, buttonName, buttonDisabled, handleClick, testId }) => {
  // Motion variants for button animation
  const buttonVariants = {
    hidden: { opacity: 1, y: 0 }, // Starts slightly above and invisible
    visible: { opacity: 1, y: 0 },  // Fades in and slides to final position
    hover: { scale: 1 }, // Slightly enlarges the button on hover
    tap: { scale: 1 }, // Shrinks when the button is pressed
  };

  return (
    <motion.button
      className={`border disabled:bg-disable_fill disabled:text-disable_stroke disabled:border-disable_stroke border-p_primary text-p_primary ${className} rounded-[8px]`}
      onClick={handleClick}
      disabled={buttonDisabled || loading}
      type={buttonType ? "submit" : "button"}
      variants={buttonVariants}
      initial="hidden"
      animate="visible"
      whileHover="hover"
      whileTap="tap"
      transition={{ duration: 0.4, ease: "easeInOut" }} // Smooth transition for hover and tap
      data-testid={testId}
    >
      {loading ? <LoadingButton /> : buttonName}
    </motion.button>
  );
};

export default SecondaryButton;
